import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { CommonAction } from '@stores/common/action';
import RecommendedSearchInput from '../RecommendedSearchInput';
import { BASE_IMG_URL } from '@images/imageUrls';
import Avatar from '@components/avatar';
import classNames from 'classnames';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface PcHeaderProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    nav?: any;   // 导航数据
    navClick?: any; // 导航点击事件
    loginClick?: any    // 登录
    avatar?: string;
    nickname?: string;
    navCurrentIndex?: any
    handleSetState?: any
    searchConfirm?: Function
    searchValue?: any   // 搜索框的值
    searchKeywords?: string[];
}
interface PCHeaderState {
    navDropShow?: any
    searchInputValue: string;  // 添加本地状态
}

type PCHeaderAllProps = PcHeaderProps & RouteComponentProps;
@inject('app', 'site', 'user')
@observer
class PCHeader extends React.Component<PCHeaderAllProps> {
    navDropdownRef = React.createRef<HTMLDivElement>();
    state: PCHeaderState = {
        navDropShow: false,
        searchInputValue: this.props.searchValue || '',  // 从props初始化
    };
    componentDidMount() {
        document.addEventListener('pointerdown', this.handleOutsideInteraction, true);
        document.addEventListener('click', this.handleOutsideInteraction, true);
        document.addEventListener('focusin', this.handleOutsideInteraction, true);
        document.addEventListener('keydown', this.handleDropdownKeyDown, true);
    }

    componentWillUnmount() {
        document.removeEventListener('pointerdown', this.handleOutsideInteraction, true);
        document.removeEventListener('click', this.handleOutsideInteraction, true);
        document.removeEventListener('focusin', this.handleOutsideInteraction, true);
        document.removeEventListener('keydown', this.handleDropdownKeyDown, true);
    }

    handleOutsideInteraction = (event: Event) => {
        if (this.state.navDropShow && event.target instanceof Node && !this.navDropdownRef.current?.contains(event.target)) {
            this.setState({ navDropShow: false });
        }
    };

    handleDropdownKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape' && this.state.navDropShow) this.setState({ navDropShow: false });
    };

     // update生命周期方法
     componentDidUpdate(prevProps: PCHeaderAllProps) {
        // 当父组件传递的 searchValue 发生变化时，同步到本地状态
        if (prevProps.searchValue !== this.props.searchValue) {
            console.log('PCHeader: searchValue 从 props 更新:', this.props.searchValue);
            this.setState({
                searchInputValue: this.props.searchValue || ''
            });
        }
    }

    // 点击显示隐藏折叠的导航菜单
    navDropClick = () => {
        let { navDropShow } = this.state;
        this.setState({
            navDropShow: !navDropShow
        })
    }

    // 输入框变化处理
    handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log(e.target.value, '改变了吗');
        const value = e.target.value;
        this.setState({ searchInputValue: value });
        this.props.handleSetState && this.props.handleSetState({ searchValue: value })
    };

    render() {
        const { site, app, user, nav, avatar, nickname, navCurrentIndex, loginClick, searchValue, ...props } = this.props;
        let { navDropShow, searchInputValue } = this.state;
        const userInfo = (user?.userInfo as any) || {};
        const navSecond = nav?.[1];  // 获取 nav 的第二个元素
        const hasMoreTopics = nav?.[2]?.length > 2;
        let showArrow = false;

        // 当关注话题 > 3 个时，始终显示下拉箭头（至少包含福利活动）
        if (hasMoreTopics) {
            showArrow = true;
        } else if (Array.isArray(navSecond) && navSecond.length > 0) {
            showArrow = navSecond.some(item => item?.isPinned === true);
        }
        return <>
            <div className={styles.headerBox}>
                <div className={styles.headerContent}>
                    <div className={styles.headerLeft}>
                        <img src={`${BASE_IMG_URL}/common/logo.png`} alt="" className={styles.headerLogo} onClick={()=> {
                            this.props.handleSetState?.({ navCurrentIndex: 'home' });
                            this.props.history.push(`/`);
                        }}/>
                        <div className={styles.navBox}>
                            <div className={classNames(styles.navItem, navCurrentIndex === 'home' ? styles.navItemActive : '')} onClick={() => {
                                this.props.navClick && this.props.navClick({}, 'home', 'home')
                            }}>精选</div>
                            {/* 关注话题不超过2个时，固定导航直接展示；未登录时也保持显示。 */}
                            {!hasMoreTopics && <>
                                {nav?.[0]?.map((item: any, index:any) => (
                                    item.isPinned ? <div className={classNames(styles.navItem, navCurrentIndex === index ? styles.navItemActive : '')} key={item.id || item.topic?.id || index} onClick={() => {
                                            this.props.navClick && this.props.navClick(item, 'topic', index)
                                        }}>{item.topic?.alias || item.topic?.name}</div> : null
                                ))}
                                <div className={classNames(styles.navItem, navCurrentIndex === 'activity' ? styles.navItemActive : '')} onClick={() => {
                                    this.props.navClick && this.props.navClick({}, 'activity', 'activity')
                                }}>福利活动</div>
                                <div className={classNames(styles.navItem, navCurrentIndex === 'goods' ? styles.navItemActive : '')} onClick={() => {
                                    this.props.navClick && this.props.navClick({}, 'goods', 'goods')
                                }}>V币商城</div>
                                <div className={classNames(styles.navItem, navCurrentIndex === 'feedback' ? styles.navItemActive : '')} onClick={() => {
                                    this.props.navClick && this.props.navClick({}, 'feedback', 'feedback')
                                }}>问题反馈</div>
                            </>}
                            {/* 关注话题超过2个时，额外话题和固定导航收进下拉菜单。 */}
                            {hasMoreTopics && <>
                                {nav?.[0].map((item: any, index:any) => (
                                    item.isPinned ? <div className={classNames(styles.navItem, navCurrentIndex === index ? styles.navItemActive : '')} key={item.id || item.topic?.id || index} onClick={() => {
                                            this.props.navClick && this.props.navClick(item, 'topic', index)
                                        }}>{item.topic?.alias || item.topic?.name}</div> : null
                                ))}
                                <div ref={this.navDropdownRef} className={styles.foldNavList}>
                                    {showArrow && <img src={`${BASE_IMG_URL}/common/arrow_b1.png`} alt="" className={classNames(styles.foldNavIcon)}
                                        role="button"
                                        tabIndex={0}
                                        aria-label="更多导航"
                                        aria-expanded={!!navDropShow}
                                        style={{
                                            transform: navDropShow ? `rotate(180deg)` : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease-in-out'
                                        }}
                                        onClick={this.navDropClick}
                                        onKeyDown={event => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                event.preventDefault();
                                                this.navDropClick();
                                            }
                                        }}
                                    />}
                                    {navDropShow && <div className={styles.foldNavBox}>
                                        {nav?.[1]?.map((second: any, key:any) => 
                                        (
                                            second.isPinned ? <div className={classNames(styles.foldNavItem)} key={second.id || second.topic?.id || key} onClick={() => {
                                                    this.setState({
                                                        navDropShow: false
                                                    })
                                                    this.props.navClick && this.props.navClick(second, 'topic', key + 2)
                                                }}>{second.topic?.alias || second.topic?.name}</div> : null
                                        )
                                             
                                        )}
                                        <div className={classNames(styles.foldNavItem)} onClick={() => {
                                            this.setState({
                                                navDropShow: false
                                            })
                                            this.props.navClick && this.props.navClick({}, 'activity', 'activity')
                                        }}>福利活动</div>
                                        <div className={classNames(styles.foldNavItem)} onClick={() => {
                                            this.setState({
                                                navDropShow: false
                                            })
                                            this.props.navClick && this.props.navClick({}, 'goods', 'goods')
                                        }}>V币商城</div>
                                        <div className={classNames(styles.foldNavItem)} onClick={() => {
                                            this.setState({
                                                navDropShow: false
                                            })
                                            this.props.navClick && this.props.navClick({}, 'feedback', 'feedback')
                                        }}>问题反馈</div>
                                    </div>}
                                    
                                </div>
                                
                            </>}
                        </div>
                    </div>
                    <div className={styles.headerRight}>
                        <div className={styles.searchBox}>
                            <RecommendedSearchInput
                                value={searchInputValue}
                                keywords={this.props.searchKeywords || []}
                                onChange={this.handleSearchChange}
                                onSearch={keyword => this.props.searchConfirm?.(keyword)}
                                inputClassName={styles.searchInput}
                                iconClassName={styles.searchIcon}
                            />
                        </div>
                        <div className={styles.messageBox} onClick={() => {
                            const platform = app?.platform || 'h5';
                            // 使用 checkLogin 检查登录状态，未登录会自动跳转到登录页
                            if (user?.checkLogin(platform)) {
                                // 已登录，跳转到个人中心
                                this.props.history.push(`/message/${user?.userInfo?.code}`);
                            }
                        }}>
                            <div className={styles.icon}></div>
                            {user.userMeta?.unreadCount > 0 && <div className={styles.num}>{user.userMeta?.unreadCount > 99 ? '99+' : user.userMeta?.unreadCount}</div>}
                        </div>
                        <div className={styles.userBox}>
                            <div  onClick={() => {
                                const { user, app } = this.props;
                                const platform = app?.platform || 'h5';
                                // 使用 checkLogin 检查登录状态，未登录会自动跳转到登录页
                                if (user?.checkLogin(platform)) {
                                    // 已登录，跳转到个人中心
                                    this.props.history.push(`/user/${user?.userInfo?.code}`);
                                }
                                
                            }}>
                                <Avatar avatarUrl={userInfo?.avatarUrl} size={28} officialSize={11} titleMark={user?.userInfo?.titleMark} userCode={user?.userInfo?.code || 0}></Avatar>
                            </div>
                            
                            {userInfo.code && <div className={styles.userSelectList}>
                                <div className={styles.userSelectItem} onClick={() => {
                                    const { user, app } = this.props;
                                    const platform = app?.platform || 'h5';
                                    // 使用 checkLogin 检查登录状态，未登录会自动跳转到登录页
                                    if (user?.checkLogin(platform)) {
                                        // 已登录，跳转到个人中心
                                        this.props.history.push(`/user/${user?.userInfo?.code}`);
                                    }
                                }}>个人中心</div>
                                <div className={styles.userSelectItem} style={{color: '#C00000'}} onClick={async () => {
                                    if (this.props.user) {
                                        await this.props.user.logoutRemote();
                                    }
                                    // this.props.history && this.props.history.push(`/`);
                                }}>退出登录</div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>;

    }
}

export default withRouter(PCHeader);
